// @flow

import type { ExtractReturn } from '@ta/common.types';
import type { Action as AllActions } from '../state';
import type { State as PageState } from '../page';

const SET_GEO_THEME = 'SET_GEO_THEME';
export const setGeoTheme = (geoThemeId: number) => ({
  type: SET_GEO_THEME,
  geoThemeId,
});

export type Action = ExtractReturn<typeof setGeoTheme>;

const emptyState = () => ({
  name: 'INSPIRATION',
  geoThemeId: null,
});

export type State = ExtractReturn<typeof emptyState>;

export default (state: PageState = emptyState(), action: AllActions): PageState => {
  switch (action.type) {
    case SET_GEO_THEME:
      return { ...state, geoThemeId: action.geoThemeId };
    default:
      return state;
  }
};
